import {
    Card,
    CardContent,
    Grid,
    Typography,
} from "@mui/material";

import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { useEffect, useState } from "react";
import { reportApi } from "../API/reportApi";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import Footer from "../Component/Footer";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb";

export default function RevenueReport() {

    const [loading, setLoading] = useState(true);
    const [byGateway, setByGateway] = useState([]);
    const [byCurrency, setByCurrency] = useState([]);

    useEffect(() => {
        Promise.all([
            reportApi.gateways().catch(() => ({ data: [] })),
            reportApi.revenue().catch(() => ({ data: [] })),
        ]).then(([gw, rev]) => {
            setByGateway((gw.data || []).map((g) => ({ gateway: g.gateway, revenue: Number(g.netRevenue || 0), count: g.paymentCount })));
            setByCurrency(rev.data || []);
            setLoading(false);
        });
    }, []);

    const gross = byGateway.reduce((s, g) => s + Number(g.revenue || 0), 0);
    const txns = byGateway.reduce((s, g) => s + Number(g.count || 0), 0);

    return (

        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <div className="UI-container">
                    <div className="UI-card">
                        <div className="UI-header">
                            <Breadcrumb breadcrumbs={[{ name: "Home", path: "/superadminmasters" }, { name: "Revenue Report", path: null }]} />

                            <div className="UI-header-content">
                                <div>
                                    <h1 className="UI-title">
                                        Revenue Report
                                    </h1>
                                    <p className="UI-subtitle">
                                        Overview of all payments
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="UI-form-container">

                            {loading ? <Typography>Loading...</Typography> : (
                            <Grid container spacing={3}>

                                <Grid item xs={12} md={4}>
                                    <Card>
                                        <CardContent>
                                            <Typography color="text.secondary">
                                                Net Revenue
                                            </Typography>

                                            <Typography variant="h5">
                                                ₹{gross.toLocaleString()}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Card>
                                        <CardContent>
                                            <Typography color="text.secondary">
                                                Transactions
                                            </Typography>

                                            <Typography variant="h5">
                                                {txns.toLocaleString()}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Card>
                                        <CardContent>
                                            <Typography color="text.secondary">
                                                Currencies
                                            </Typography>

                                            <Typography variant="h5">
                                                {byCurrency.length === 0 ? "—" : byCurrency.map((c) => `${c.currency}: ${Number(c.revenue || 0).toLocaleString()}`).join(" · ")}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12}>

                                    <Card>

                                        <CardContent>

                                            <Typography variant="h6" mb={3}>
                                                Revenue By Gateway
                                            </Typography>

                                            {byGateway.length === 0 ? <Typography color="text.secondary">No payment data yet.</Typography> : (
                                            <ResponsiveContainer
                                                width="100%"
                                                height={400}
                                            >

                                                <BarChart data={byGateway}>

                                                    <CartesianGrid
                                                        strokeDasharray="3 3"
                                                    />

                                                    <XAxis dataKey="gateway" />

                                                    <YAxis />

                                                    <Tooltip />

                                                    <Bar
                                                        dataKey="revenue"
                                                    />

                                                </BarChart>

                                            </ResponsiveContainer>
                                            )}

                                        </CardContent>

                                    </Card>

                                </Grid>

                            </Grid>
                            )}

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
